<template>

  <v-form @keyup.native.enter="onKeyDown"
          v-on:submit.prevent="onKeyDown"
          lazy-validation>
    <v-layout>
      <v-text-field placeholder="Message"
                    id="message"
                    v-model="message"
                    prepend-icon="textsms"
                    :rules="messageRules"
                    :counter="50"
                    type="text" />
    </v-layout>
    <v-btn outline
           color="indigo"
           type="submit">Send</v-btn>
  </v-form>

</template>

<script>
export default {
  name: 'MessageInput',
  props: ['onSend'],
  methods: {
    onKeyDown () {
      if (this.message) {
        var cleanString = this.message.replace(/[|~`"<>()/\\{}^]/g, '')
        this.onSend(cleanString.substring(0, 50))
        this.message = ''
      }
    }
  },
  data () {
    return {
      message: '',
      messageRules: [
        v => v.length <= 50 || 'Each line should be less than 50 characters'
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MessageInput.vue